import React, { useState } from "react";
import { Provider } from "../types";

export const SearchProviderContext = React.createContext<{
  term: string;
  setTerm: (term: string) => void;
  providers: Provider[];
  filteredProviders: Provider[];
  setProviders: (providers: Provider[]) => void;
}>({
  term: "",
  setTerm: (term: string) => {},
  providers: [],
  filteredProviders: [],
  setProviders: (providers: Provider[]) => {}
});

export const SearchProviderContextProvider = ({ children }: any) => {
  const [term, _setTerm] = useState<string>("");
  const [providers, _setProviders] = useState<Provider[]>([]);
  const [filteredProviders, setFilteredProviders] = useState<Provider[]>([]);

  const setProviders = (_providers: Provider[]) => {
    if (_providers == providers) {
      return;
    }

    _setProviders(_providers);
    setFilteredProviders(
      _providers.filter(provider => {
        return !provider.is_hidden;
      })
    );
  };

  const setTerm = (term: string) => {
    _setTerm(term);
    setFilteredProviders(
      providers.filter(provider => {
        return (
          filterIsSearching(term, provider) && filterTermMatch(term, provider)
        );
      })
    );
  };

  // Filter hidden providers when not searching
  const filterIsSearching = (term: string, provider: Provider) => {
    return term == "" ? !provider.is_hidden : true;
  };

  const filterTermMatch = (term: string, provider: Provider) => {
    return provider.name.toLowerCase().includes(term.toLowerCase());
  };

  return (
    <SearchProviderContext.Provider
      value={{
        term,
        setTerm,
        providers,
        filteredProviders,
        setProviders
      }}
    >
      {children}
    </SearchProviderContext.Provider>
  );
};
